import { SelectOption } from "@disco-ui"
import DiscoTableFilterDropdown from "@disco-ui/table/header/search/DiscoTableFilterDropdown"
import { TestIDProps } from "@utils/typeUtils"

type AdminMembersReportContentUsagesTableHasViewedOption = SelectOption<string | null>

export type AdminMembersReportContentUsagesTableHasViewedFilterState = {
  hasViewed: AdminMembersReportContentUsagesTableHasViewedOption | null
}

interface AdminMembersReportContentUsagesTableHasViewedFilterProps extends TestIDProps {
  filterState: AdminMembersReportContentUsagesTableHasViewedFilterState
  setFilterState: (
    state: AdminMembersReportContentUsagesTableHasViewedFilterState
  ) => void
}

function AdminMembersReportContentUsagesTableHasViewedFilter({
  filterState,
  setFilterState,
}: AdminMembersReportContentUsagesTableHasViewedFilterProps) {
  return (
    <DiscoTableFilterDropdown
      testid={"AdminMembersReportContentUsagesTableHasViewed.content-location-select"}
      isNested
      options={[
        { value: null, title: "All" },
        { value: "yes", title: "Yes", context: { filterTagTitle: "Viewed" } },
        { value: "no", title: "No", context: { filterTagTitle: "Not Viewed" } },
      ]}
      onOptionSelect={(option) => setFilterState({ hasViewed: option })}
      selectedOption={filterState.hasViewed}
      dropdown={{
        label: `Viewed`,
      }}
    />
  )
}

export default AdminMembersReportContentUsagesTableHasViewedFilter
